import React, { useState } from 'react';
import { Button } from "@curves/ui-base";
import { SmsTemplateCreateDialog } from '@icoach/message/dialog/';

const SmsTemplateCreateButton = React.forwardRef((props, ref) => {
    const [open, setOpen] = useState(false);

    return (
        <React.Fragment>
            <Button variant="outlined" onClick={() => setOpen(true)}>
                新增公版簡訊
            </Button>
            <SmsTemplateCreateDialog open={open} onClose={() => setOpen(false)} {...props} />
        </React.Fragment>
    );
});

export default SmsTemplateCreateButton;
